import PropTypes from "prop-types";
import React from "react";
import { Flex, Box, useMantineTheme } from "@mantine/core";
import { useStylesBorderedContent } from "../utils/mantine/useStylesBorderedContent";

export const BorderedContent = ({
  children,
  id = "",
  additionalClassName = "",
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesBorderedContent } = useStylesBorderedContent();
  return (
    <Flex
      id={id}
      className={classesBorderedContent.borderedContent}
      align={theme.flex.align.center}
      direction="column"
    >
      <Box className={additionalClassName + " borders"}>{children}</Box>
      <Box className="shadow"></Box>
    </Flex>
  );
};
BorderedContent.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  additionalClassName: PropTypes.string,
};
